// src/components/SlideShow.js
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./SlideShow.css";
import teachWithUs from "../assets/TEACHWITHUS.png";
import thaiDisney from "../assets/Thai_Disney.png";
import canada from "../assets/canada.png";

// Array of slide data
const slides = [
  /*{
    href: "/job-opportunity",
    src: teachWithUs,
    alt: "picOne",
  },*/
  {
    href: "/disney",
    src: thaiDisney,
    alt: "picTwo",
  },
  {
    href: "/tamwood",
    src: canada,
    alt: "picThree",
  },
];


const SlideShow = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto-advance slides every 5 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
    }, 5000);

    return () => clearInterval(timer);
  }, []);

  // Handlers for manual navigation
  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? slides.length - 1 : prevIndex - 1
    );
  };

  return (
    <div className="slideshow">
      <div className="slideshow-container flex">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`mySlides fade ${index === currentIndex ? "active" : ""}`}
            style={{ display: index === currentIndex ? "block" : "none" }}
          >
            <a href={slide.href}>
              <img src={slide.src} alt={slide.alt} />
            </a>
          </div>
        ))}

        {/* Uncomment below if you want manual previous/next buttons */}
        <a className="prev" onClick={prevSlide}>
          &#10094;
        </a>
        <a className="next" onClick={nextSlide}>
          &#10095;
        </a>
      </div>
      <br />

      <div className="dots" style={{ textAlign: "center" }}>
        {slides.map((_, index) => (
          <span
            key={index}
            className={`dot ${index === currentIndex ? "active" : ""}`}
            onClick={() => goToSlide(index)}
          ></span>
        ))}
      </div>
    </div>
  );
};

export default SlideShow;
